<template>
  <div>
    <v-card class="elevation-2 ml-5 mr-5 mt-5 mb-5 pa-3">
      <v-row dense>
        <v-col cols="12">
          <h4>Lihat Laporan Keuangan</h4>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="8" md="6" lg="4">
          <v-radio-group
            v-model="submissionType"
            @change="createLaporanKeuangan"
            row
            class="mt-0"
          >
            <v-radio label="Pemasukan" value="PEMASUKAN"></v-radio>
            <v-radio label="Pengeluaran" value="PENGELUARAN"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="12" md="6" lg="4">
          <v-text-field
            type="datetime-local"
            v-model="fromDate"
            label="Dari Tanggal"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="4">
          <v-text-field
            type="datetime-local"
            v-model="toDate"
            label="Sampai Tanggal"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-btn
            :disabled="
              fromDate == '' || toDate == '' || toDate < fromDate ? true : false
            "
            color="primary"
            small
            @click="createLaporanKeuangan"
            >Lihat Laporan Keuangan</v-btn
          >

          <v-btn
            :disabled="
              fromDate == '' || toDate == '' || toDate < fromDate ? true : false
            "
            @click="resetFilter"
            style="margin-left: 10px"
            outlined
            small
            fab
            color="indigo"
          >
            <v-icon>mdi-backup-restore</v-icon>
          </v-btn>

          <v-btn
            :disabled="listItems.length > 0 ? false : true"
            @click="onClickPrint"
            style="float: right"
            color="primary"
          >
            Print
          </v-btn>
        </v-col>
      </v-row>
      <!-- <v-card-title>
        Lihat Laporan Keuangan {{swipeSubmissionType[submissionType]}}
      </v-card-title>
      <v-card-text>
        <v-radio-group v-model="submissionType" row>
          <v-radio label="Pemasukan" value="pemasukan"></v-radio>
          <v-radio label="Pengeluaran" value="pengeluaran"></v-radio>
        </v-radio-group>
        <v-text-field type="datetime-local" v-model="fromDate" label="Dari Tanggal" :max-width="50"></v-text-field>
        <v-text-field type="datetime-local" v-model="toDate" label="Sampai Tanggal"></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="createLaporanKeuangan">Lihat Laporan Keuangan</v-btn>
      </v-card-actions> -->
    </v-card>
    <v-card elevation="2" class="ml-5 mr-5 mt-5 mb-5">
      <v-data-table
        :headers="headers"
        :items="listItems"
        class="elevation-1"
        disable-pagination
        :hide-default-footer="true"
      >
        <template v-slot:[`item.no`]="{ item }">
          {{ listItems.indexOf(item) + 1 + (currentPage - 1) * pageSize + "." }}
        </template>
        <template v-slot:[`item.totals`]="{ item }">
          {{ convertCurrency(item.totals) }}
        </template>
        <template v-slot:[`item.harga`]="{ item }">
          {{ convertCurrency(item.harga) }}
        </template>
        <template v-slot:[`item.jumlah`]="{ item }">
          {{ Number(item.jumlah) }}
        </template>

        <template v-slot:footer>
          <v-divider></v-divider>
          <div style="padding: 0 5em">
            <div :class="`d-flex justify-end`">
              <h5>
                Sub Total
                {{
                  submissionType == "PEMASUKAN" ? "Pemasukan" : "Pengeluaran"
                }}
                :
                <b
                  v-if="submissionType == 'PEMASUKAN'"
                  style="color: #43a047"
                  >{{ convertCurrency(sub_total) }}</b
                ><b v-else style="color: red">{{
                  convertCurrency(sub_total)
                }}</b>
              </h5>
            </div>
            <div :class="`d-flex justify-end`">
              <h5>
                {{
                  submissionType == "PEMASUKAN"
                    ? "Pemasukan Cancel"
                    : "Pengeluaran Cancel"
                }}
                :
                <b
                  v-if="submissionType == 'PEMASUKAN'"
                  style="color: #43a047"
                  >{{ convertCurrency(total_canceled) }}</b
                ><b v-else style="color: red">{{
                  convertCurrency(total_canceled)
                }}</b>
              </h5>
            </div>
          </div>
          <hr />
          <div style="padding: 0 5em">
            <div :class="`d-flex justify-end`">
              <h5>
                Total
                {{
                  submissionType == "PEMASUKAN" ? "Pemasukan" : "Pengeluaran"
                }}
                :
                <b
                  v-if="submissionType == 'PEMASUKAN'"
                  style="color: #43a047"
                  >{{ convertCurrency(total) }}</b
                ><b v-else style="color: red">{{ convertCurrency(total) }}</b>
              </h5>
            </div>
          </div>
        </template>
      </v-data-table>

      <div style="padding: 20px" class="d-flex">
        <v-col class="d-flex" cols="12" sm="1">
          <small style="margin-top: 30px">Item show</small>
        </v-col>
        <v-col class="d-flex" cols="12" sm="1">
          <v-select
            :disabled="listItems.length > 0 ? false : true"
            v-model="pageSize"
            :items="pageSizes"
            @change="handlePageSizeChange"
            style="font-size: 10px"
          ></v-select>
        </v-col>
        <v-col class="d-flex" cols="12" sm="12">
          <v-pagination
            style="width: auto"
            v-model="currentPage"
            :length="totalPages"
            total-visible="10"
            next-icon="mdi-menu-right"
            prev-icon="mdi-menu-left"
            @input="handlePageChange"
          ></v-pagination>
          <small style="margin-top: 28px"
            >{{ from }}-{{ to }} of {{ totalData }}</small
          >
        </v-col>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import forEach from "lodash/forEach";
import find from "lodash/find";
import isEmpty from "lodash/isEmpty";
import { formatCurrency } from "@/libs/number";

export default {
  data: () => ({
    headers: [
      {
        text: "No.",
        align: "left",
        value: "no",
      },
      { text: "Nama Item", value: "item_name" },
      { text: "Jumlah", value: "jumlah" },
      { text: "Harga", value: "harga" },
      { text: "Total", value: "totals" },
    ],
    listItems: [],
    swipeSubmissionType: {
      PEMASUKAN: "PEMASUKAN",
      PEMASUKAN: "PEMASUKAN",
    },
    fromDate: "",
    toDate: "",
    submissionType: "PEMASUKAN",
    pageSizes: [10, 50, 100],
    currentPage: 1,
    totalPages: 0,
    pageSize: 10,
    from: 0,
    to: 0,
    totalData: 0,
    total_canceled: 0,
    sub_total: 0,
    total: 0,
  }),

  computed: {
    ...mapGetters({}),
  },

  watch: {},

  created() {
    // this.initialize();
  },

  methods: {
    ...mapActions({
      getLaporan: "laporan/getLaporan",
    }),
    onClickPrint() {
      window.open(
        "/print-laporan/" +
          this.fromDate +
          "/" +
          this.toDate +
          "/" +
          this.submissionType,
        "_blank"
      );
    },
    async initialize() {},
    async createLaporanKeuangan() {
      if (
        !(
          this.fromDate == "" ||
          this.toDate == "" ||
          this.toDate < this.fromDate
        )
      ) {
        this.listItems = [];
        const payload = {
          date_from: this.fromDate,
          date_to: this.toDate,
          type: this.submissionType,
          page: this.currentPage,
          jum: this.pageSize,
        };

        let response = await this.getLaporan(payload);
        this.totalPages = response.data.attributes.items.last_page;
        this.currentPage = response.data.attributes.items.current_page;
        this.from = response.data.attributes.items.from;
        this.to = response.data.attributes.items.to;
        this.totalData = response.data.attributes.items.total;
        this.total_canceled = response.data.attributes.total_canceled;
        this.total = response.data.attributes.total;
        this.sub_total = response.data.attributes.sub_total;
        await forEach(response.data.attributes.items.data, (data) => {
          data.harga =
            data.type == "PEMASUKAN" ? data.harga_jual : data.harga_beli;
          this.listItems.push(data);
        });
      }
    },
    async handlePageSizeChange(size) {
      this.listItems = [];
      this.pageSize = size;
      this.currentPage = 1;

      const payload = {
        date_from: this.fromDate,
        date_to: this.toDate,
        type: this.submissionType,
        page: this.currentPage,
        jum: size,
      };

      let response = await this.getLaporan(payload);
      this.totalPages = response.data.attributes.items.last_page;
      this.currentPage = response.data.attributes.items.current_page;
      this.from = response.data.attributes.items.from;
      this.to = response.data.attributes.items.to;
      this.totalData = response.data.attributes.items.total;
      this.total_canceled = response.data.attributes.total_canceled;
      this.total = response.data.attributes.total;
      this.sub_total = response.data.attributes.sub_total;
      await forEach(response.data.attributes.items.data, (data) => {
        data.harga =
          data.type == "PEMASUKAN" ? data.harga_jual : data.harga_beli;
        this.listItems.push(data);
      });
    },
    async handlePageChange(value) {
      this.listItems = [];
      this.currentPage = value;
      const payload = {
        date_from: this.fromDate,
        date_to: this.toDate,
        type: this.submissionType,
        page: value,
        jum: this.pageSize,
      };

      let response = await this.getLaporan(payload);
      this.totalPages = response.data.attributes.items.last_page;
      this.currentPage = response.data.attributes.items.current_page;
      this.from = response.data.attributes.items.from;
      this.to = response.data.attributes.items.to;
      this.totalData = response.data.attributes.items.total;
      this.total_canceled = response.data.attributes.total_canceled;
      this.total = response.data.attributes.total;
      this.sub_total = response.data.attributes.sub_total;
      await forEach(response.data.attributes.items.data, (data) => {
        data.harga =
          data.type == "PEMASUKAN" ? data.harga_jual : data.harga_beli;
        this.listItems.push(data);
      });
    },

    async resetFilter() {
      this.listItems = [];
      this.fromDate = "";
      this.toDate = "";

      this.totalPages = 0;
      this.currentPage = 1;
      this.from = 0;
      this.to = 0;
      this.totalData = 0;

      this.total_canceled = 0;
      this.sub_total = 0;
      this.total = 0;
    },
    convertCurrency(total) {
      return "Rp. " + formatCurrency(total);
    },
  },
};
</script>
<style>
</style>